import { Contrast, DarkMode, LightMode } from '@mui/icons-material';
import type { ReactElement } from 'react';
import type { ColorMode } from '@/stores/theme';

export const themeModeLabels: Record<ColorMode, string> = {
  light: 'Hell',
  dark: 'Dunkel',
  system: 'System',
};

export function getColorModeLabel(mode: ColorMode): string {
  return themeModeLabels[mode];
}

export function getColorModeIcon(mode: ColorMode): ReactElement {
  switch (mode) {
    case 'light':
      return <LightMode fontSize="small" />;
    case 'dark':
      return <DarkMode fontSize="small" />;
    case 'system':
      return <Contrast fontSize="small" />;
  }
}

export const COLOR_MODES: ColorMode[] = ['light', 'dark', 'system'];

export function getColorModeOptionIcon(mode: ColorMode): ReactElement {
  switch (mode) {
    case 'light':
      return <LightMode />;
    case 'dark':
      return <DarkMode />;
    case 'system':
      return <Contrast />;
  }
}
